import { useEffect } from "react";

/**
 * Custom hook to calculate and update shareholder totals in Formik form
 * @param {Array} shareholderArray - Array of shareholder objects
 * @param {Object} formikRef - Ref to Formik instance containing setFieldValue
 */
const useShareholderTotals = (shareholderArray, formikRef) => {
  useEffect(() => {
    if (formikRef.current) {
      const totalShares = shareholderArray.reduce((sum, shareholder) => {
        const shares = Number(shareholder?.number_of_shares) || 0;
        return sum + shares;
      }, 0);
      
      const totalIssuedShares = shareholderArray.reduce((sum, shareholder) => {
        const shares = Number(shareholder?.issued_share_capital) || 0;
        return sum + shares;
      }, 0);
      
      const totalPaidUpShares = shareholderArray.reduce((sum, shareholder) => {
        const shares = Number(shareholder?.paid_up_capital) || 0;
        return sum + shares;
      }, 0);
      
      formikRef.current.setFieldValue("total_number_of_shares", totalShares);
      formikRef.current.setFieldValue(
        "total_issued_share_capital",
        totalIssuedShares
      );
      formikRef.current.setFieldValue(
        "total_paid_up_share_capital",
        totalPaidUpShares
      );
    }
  }, [shareholderArray, formikRef]);
};

export default useShareholderTotals;

